import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ExtractedShowcase, ShowcasesEntity, ShowcasesTypes } from 'search/full-card/models/showcases';
import { selectAllShowcases, ShowcasesState } from 'search/full-card/reducers/showcases.reducer';
import { ShowcaseHelperService } from 'search/full-card/services/showcase-helper.service';

@Component({
  selector: 'app-showcases-container',
  templateUrl: './showcases-container.component.html',
})
export class ShowcasesContainerComponent implements OnInit, OnDestroy {
  @Input() public entity: ShowcasesEntity;
  @Output() public scrollToContent: EventEmitter<void> = new EventEmitter();
  public subscriptions = new Subscription();
  public showcaseType: string;
  public showcases: ExtractedShowcase[];
  public showcasesTypes = ShowcasesTypes;
  public isSeeAllMultiple = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store<ShowcasesState>,
    private readonly cdRef: ChangeDetectorRef,
    private readonly showcaseHelper: ShowcaseHelperService,
  ) {
  }

  public ngOnInit() {
    this.subscriptions.add(this.route.queryParams.subscribe((params) => {
      this.showcaseType = params.showcase;
      this.isSeeAllMultiple = params.showcase === params.identifier;
    }));

    this.subscriptions.add(this.store.pipe(select(selectAllShowcases)).subscribe((data) => {
      this.showcases = data.map((showcase) => {
        return this.showcaseHelper.extractShowcaseData(showcase.type, showcase, showcase.isMultiple);
      });
      this.cdRef.markForCheck();
    }));
  }

  public onScrollToContent() {
    this.scrollToContent.emit();
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
